import { useQuery } from 'react-query'
import { axios } from 'lib'
import { toast } from 'react-toastify'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'
import { OrderProduct } from 'modules/orders/types'

type Products = PaginatedParams & {
  unityId: string
}

const loadOrderProducts = (data: Products): PaginatedResponse<OrderProduct> => {
  const { page = 1, limit = 10 } = data

  return axios.get(`/orders/products`, {
    params: {
      page,
      limit,
      ...data
    }
  })
}

export function useLoadOrderProducts(query: Products) {
  return useQuery(
    ['loadOrderProducts', query],
    () => loadOrderProducts(query),
    {
      staleTime: 0,
      cacheTime: 0,
      enabled: !!query.unityId,
      onError: () =>
        toast.error('Não foi possível carregar os produtos!', {
          toastId: 'loadOrderProducts'
        })
    }
  )
}
